import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Global } from '../../global'
import { UtilityService } from '../../../services/Acc_Utility.service';
import { UserRegistration } from '../../../models/user.registration.interface';
import { UserService } from  '../../../services/user.service';
import { FixAmount } from '../../../models/fix-amount';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-fix-amount-form',
  templateUrl: './fix-amount.component.html',
  styleUrls: ['./fix-amount.component.css']
})
export class FixAmountComponent implements OnInit {
  ArrLabels: any;
  labels: any = {};

  errors: string;  
  isRequesting: boolean;
  submitted: boolean = false;

  constructor(
    private UtilityService: UtilityService,
    private global: Global,
    public snackBar: MatSnackBar,
    private router: Router
  ) { }

  ngOnInit() {
    this.getLabels();
    this.getAmounts()
  }

  fixAmount: FixAmount;
  getAmounts() {
    this.UtilityService.getFixAmount("0")
      .subscribe(response => {
        if (response) {
          this.fixAmount = response as FixAmount;
          //this.ArrLabels = response;
          //this.setLabels();
        }
      },
        error => console.log(error))
  } 

  changeAmounts({ value, valid }: { value: FixAmount, valid: boolean }) {
    this.submitted = true;
    this.isRequesting = true;
    this.errors='';
    if(valid)
    {
       
      this.UtilityService.postFixAmount(value)
                  .finally(() => this.isRequesting = false)
                  .subscribe(
                    result => {
                      if (result) {
                        this.snackBar.open("تغییرات با موفقیت ثبت شد", "", { duration: 2000, })
                    }},
                    errors => { this.errors = errors; console.log(this.errors)});
    }      
  }

 getLabels(){
  this.UtilityService.getLabels('account-create',this.global.lang)
    .subscribe(response => {
        if(response){
            this.ArrLabels = response;
            this.setLabels();
        }
    },
    error => console.log(error))
}
 setLabels(){

  this.labels['Create-Account-Title'] = this.ArrLabels.find( (o:any) => o.key === 'Create-Account-Title').value;
  this.labels['FirstName'] = this.ArrLabels.find( (o:any) => o.key === 'FirstName').value;
  this.labels['LastName'] = this.ArrLabels.find( (o:any) => o.key === 'LastName').value;
  this.labels['Email'] = this.ArrLabels.find( (o:any) => o.key === 'Email').value;
  this.labels['Password'] = this.ArrLabels.find( (o:any) => o.key === 'Password').value;
  this.labels['Location'] = this.ArrLabels.find( (o:any) => o.key === 'Location').value;
  this.labels['Signup'] = this.ArrLabels.find( (o:any) => o.key === 'Signup').value;

  // alerts
  this.labels['Error'] = this.ArrLabels.find( (o:any) => o.key === 'Error').value;
}
}



// WEBPACK FOOTER //
// ./src/app/components/settings/fix-amount/fix-amount.component.ts